export default {
  start: 'Take a quick tour',
  skip: 'Skip',
  next: 'Next',
  finish: 'Finish',
} as const;
